import React from 'react';


function FutureVision() {
  return (
    <div className="bg-[#0c2340] text-white py-16 px-6 lg:px-10  duration-300 ease-in-out">
                <h2 className="text-2xl lg:text-2xl font-bold lg:text-left md:ml-6">OUR JOURNEY AND</h2>
                <h3 className="text-2xl lg:text-2xl font-bold mb-8 lg:text-left md:ml-6">FUTURE VISION</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="border-r-2 border-b-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">Our Beginnings</h3>
          <p className="text-gray-300">AKT Corp started with a vision to deliver top-quality industrial solutions and establish strong global relationships.</p>
        </div>
        <div className="border-l-2 border-b-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">Milestones of Growth</h3>
          <p className="text-gray-300">From a small trading company, we’ve expanded our portfolio and become a trusted name in the industrial trade industry, offering a wide range of products.</p>
        </div>
        <div className="border-r-2 border-b-2 border-t-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">A Legacy of Quality</h3>
          <p className="text-gray-300">We’ve built a reputation for high-quality products and customer service, always striving for excellence and continuous improvement.</p>
        </div>
        <div className="border-l-2 border-t-2 border-b-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">Client-Focused Solutions</h3>
          <p className="text-gray-300">We focus on understanding our clients' needs, providing tailored solutions that drive their success and exceed expectations.</p>
        </div>
        <div className="border-r-2 border-t-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">Sustainable Practices</h3>
          <p className="text-gray-300">We integrate eco-friendly solutions and responsible sourcing to ensure a positive impact on both business and the environment.</p>
        </div>
        <div className="border-l-2 border-t-2 border-gray-300 p-6">
          <h3 className="text-2xl font-semibold mb-2">Collaborative Partnerships</h3>
          <p className="text-gray-300">By working closely with clients and partners, we deliver exceptional, results-driven solutions that consistently exceed expectations.</p>
        </div>
      </div>
    </div>
  );
}

export default FutureVision;